import React from 'react';
import PropTypes from 'prop-types';
import { Card, FloatGroup, Select } from 'modules/common';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

function AcceptContactButton({ editedUpsell, onUpdateEditedUpsell, className, subtitle }) {
  const downloadContactButtonText = [
    { value: 'Download Contact Card', label: 'Download Contact Card' },
    { value: 'Save Contact Card', label: 'Save Contact Card' },
    { value: 'Add Contact Card', label: 'Add Contact Card' },
    { value: 'Click to Download Contact Card', label: 'Click to Download Contact Card' },
  ];

  // Find the selected option object that matches the stored value, default to 'download'
  const currentValue = editedUpsell?.accept;
  const selectedOption = downloadContactButtonText.find(option => option.value === currentValue);

  const handleChange = event => {
    onUpdateEditedUpsell(event);
  };

  return (
    <Row className={className}>
      <Col sm={12} md={12}>
        <Card.Title subtitle={subtitle}>Download Contact Button Text</Card.Title>
        <FloatGroup className="accept-form-group">
          <Select
            id="accept"
            name="accept"
            maxLength="100"
            disabled={editedUpsell._isDisabled}
            value={selectedOption}
            options={downloadContactButtonText}
            onChange={handleChange}
            ariaLabel="Download Contact Button Text"
            placeholder="Download Contact Card"
            label="Download Contact Button Text"
            validators={['required']}
            errorMessages={['Download Contact Button Text is required.']}
          />
        </FloatGroup>
      </Col>
    </Row>
  );
}

AcceptContactButton.propTypes = {
  editedUpsell: PropTypes.object.isRequired,
  className: PropTypes.string,
  onUpdateEditedUpsell: PropTypes.func.isRequired,
  subtitle: PropTypes.string,
};

AcceptContactButton.defaultProps = {
  className: '',
  subtitle: 'Select a copy option for the download contact button.',
};

export default AcceptContactButton;
